import React from 'react'

import { Container } from '../../components/Bootstrap'
import Panel from '../../components/Panel'
import TagCloud from '../../components/TagCloud'

const data = [
	{ text: 'Ground Breaking', size: 2.08 },
	{ text: 'Independent', size: 2.1 },
	{ text: 'Empowerment', size: 4 },
	{ text: 'Possibilities', size: 2.78},
	{ text: 'Innovation', size: 2.05 },
	{ text: 'Accessibility', size: 2.222 },
	{ text: 'Living', size: 1.4444 },
	{ text: 'Advocacy', size: 2.2222 },
	{ text: 'Anti-Ableism', size: 2.222 },
	{ text: 'Choice', size: 4.9444 },
	{ text: 'Collaboration', size: 2.222 },
]

const Words = () => (
	<Panel colour="#ffffff">
		<h2>One Word to describe CILT</h2>
		<Container>
			<TagCloud words={data} />
		</Container>
	</Panel>
)

export default Words
